import {
  brandBgDataFile,
  BrandBgDataFile,
  brandBgDataHeight,
  BrandBgDataHeight,
  brandBgDataWidth,
  BrandBgDataWidth,
  brandEntityId,
  BrandEntityId,
  RoomId,
  roomId
} from "@common/domain";
import { JsonSchemaValidator } from "@common/json-schema-validator";

export class RoomBrandBgCreateRequestDTO {
  private static validation = JsonSchemaValidator.compile(
    RoomBrandBgCreateRequestDTO.validationSchema()
  );

  constructor(readonly data: RoomBrandBgCreateRequest) {
    JsonSchemaValidator.assert(RoomBrandBgCreateRequestDTO.validation, data);
  }

  private static validationSchema() {
    return {
      type: "object",
      required: ["roomId", "brandId", "data", "width", "height"],
      properties: {
        roomId,
        brandId: brandEntityId,
        data: brandBgDataFile,
        width: brandBgDataWidth,
        height: brandBgDataHeight
      },
      additionalProperties: false
    };
  }
}

interface RoomBrandBgCreateRequest {
  roomId: RoomId;
  brandId: BrandEntityId;
  data: BrandBgDataFile;
  width: BrandBgDataWidth;
  height: BrandBgDataHeight;
}
